import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";

function Thankyou() {
  const navigate = useNavigate();
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");
  }, []);
  const handleClick = () => {
    ctaClickEvent(
      "Back",
      "thank you page",
      "button",
      0,
      "https://campaigns.icicibank.com/hl/balanceTransfer/ncaProduct/index.html"
    );

    navigate("/");
  };
  return (
    <>
      <div className="container">
        <button onClick={handleClick} className="free_back thank_you_back">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/back_white.svg"}
            width="12"
            alt="<"
          />
          Back
        </button>
      </div>
      <article className="thank-you ">
        <div className="popup-icon">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/thank-you.svg"}
            alt="tick"
            width={100}
            height={100}
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          {/* <h2>Thank You</h2> */}
          <p>
            Thank you for your interest in ICICI Bank Home Loan Balance
            Transfer. Our representative will get in touch with you from a
            number starting with 1600-XX-XXXX
          </p>
          <h3 className="mt-3 fsmall">
            In the meantime, to learn more about
            <br className="br3" /> ICICI Bank Home Loan Balance Transfer, please{" "}
            <a
              href="#"
              target="_blank"
              onClick={() => {
                ctaClickEvent(
                  "click here",
                  "thank you page",
                  "text link",
                  0,
                  "https://www.icicibank.com/personal-banking/loans/home-loan"
                );
              }}
            >
              click here.
            </a>
          </h3>
        </div>
      </article>
    </>
  );
}

export default Thankyou;
